import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=1196adff&scoped=true&"
import script from "./PrimaryButton.vue?vue&type=script&lang=ts&"
export * from "./PrimaryButton.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryButton.vue?vue&type=style&index=0&id=1196adff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1196adff",
  null
  
)

export default component.exports